/* VELANOVA 27-oct-2026 · Selector «Aroma» diseño B: desplegable con buscador (sin tildes) y lista A–Z.
   Debajo sigue el <select> nativo de Dawn: al elegir se cambia su valor y se dispara «change», así Dawn
   actualiza variante, precio, imagen y ?variant= como siempre. Usa delegación de eventos porque Dawn vuelve a
   pintar <variant-selects> tras cada cambio. Aroma preseleccionado: data-vn-default (metacampo
   velanova.aroma_por_defecto), solo si la URL no trae ?variant=.
   28-oct-2026: la lista muestra como máximo 6 aromas (alto medido con las opciones reales) y el resto con scroll;
   el pie «Desliza para ver los N aromas» solo aparece si hay más de 6 resultados. */
(function () {
  if (window.vnAromasB) return; window.vnAromasB = true;
  var norm = function (s) { return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim(); };
  var lastPointer = 'mouse';
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

  function root(el) { return el && el.closest ? el.closest('[data-vn-cb]') : null; }
  function parts(r) {
    return { r: r, sel: r.querySelector('[data-vn-cb-select]'), btn: r.querySelector('.vn-cb__btn'), panel: r.querySelector('.vn-cb__panel'),
      input: r.querySelector('.vn-cb__input'), list: r.querySelector('.vn-cb__list'), empty: r.querySelector('.vn-cb__empty'),
      live: r.querySelector('[data-vn-cb-live]') };
  }
  function opts(p) { return Array.prototype.slice.call(p.list.querySelectorAll('.vn-cb__opt')); }
  function visible(p) { return opts(p).filter(function (o) { return !o.hidden; }); }
  function setActive(p, o, scroll) {
    opts(p).forEach(function (x) { x.classList.toggle('is-active', x === o); });
    if (o) { p.input.setAttribute('aria-activedescendant', o.id); p.list.setAttribute('aria-activedescendant', o.id); if (scroll !== false) o.scrollIntoView({ block: 'nearest' }); }
    else { p.input.removeAttribute('aria-activedescendant'); p.list.removeAttribute('aria-activedescendant'); }
  }
  function active(p) { return p.list.querySelector('.vn-cb__opt.is-active'); }
  function filtrar(p) {
    var q = norm(p.input.value), n = 0, all = opts(p);
    all.forEach(function (o) { var ok = !q || norm(o.getAttribute('data-value')).indexOf(q) !== -1; o.hidden = !ok; if (ok) n++; });
    p.empty.hidden = n !== 0;
    var foot = p.r.querySelector('.vn-cb__foot'); if (foot) foot.hidden = n <= 6;
    tope(p);
    p.live.textContent = q ? (n === 0 ? 'Ningún aroma coincide' : (n === 1 ? '1 aroma encontrado' : n + ' aromas encontrados')) : '';
    var a = active(p); if (!a || a.hidden) setActive(p, visible(p)[0] || null);
  }
  /* alto máximo = 6 aromas visibles; en pantallas bajas se reduce para que el panel no salga de la pantalla */
  function tope(p) {
    var v = visible(p); if (p.panel.hidden) return;
    if (v.length <= 6) { p.list.style.maxHeight = ''; return; }
    var h = v[5].offsetTop + v[5].offsetHeight - v[0].offsetTop;
    var extra = p.panel.offsetHeight - p.list.offsetHeight, room = window.innerHeight - extra - 24 - (p.btn.offsetHeight || 48);
    p.list.style.maxHeight = Math.ceil(Math.max(Math.min(h, room), v[0].offsetHeight * 3)) + 'px';
  }
  function abrir(p, focusSearch) {
    cerrarTodos(p.r);
    p.panel.hidden = false; p.btn.setAttribute('aria-expanded', 'true'); p.r.classList.add('is-open');
    p.input.value = ''; filtrar(p);
    var cur = p.list.querySelector('.vn-cb__opt[aria-selected="true"]') || visible(p)[0];
    setActive(p, cur, false);
    /* se desplaza hasta el aroma elegido: queda 3.º de 6, alineado para ver 6 aromas completos */
    if (cur) { var v = visible(p), ci = v.indexOf(cur), st = Math.max(0, Math.min(ci - 2, v.length - 6)); p.list.scrollTop = v.length ? v[st].offsetTop - v[0].offsetTop : 0; }
    if (focusSearch) p.input.focus({ preventScroll: true }); else p.list.focus({ preventScroll: true });
    var rect = p.panel.getBoundingClientRect();
    /* que el panel quede entero en pantalla (margen para la barra fija «Agregar al carrito» del móvil) */
    var marg = window.innerWidth < 750 ? 96 : 16;
    if (rect.bottom > window.innerHeight - marg) window.scrollBy({ top: Math.max(0, Math.min(rect.bottom - window.innerHeight + marg, rect.top - 140)), behavior: 'instant' });
  }
  function cerrar(p, devolverFoco) {
    if (p.panel.hidden) return;
    p.panel.hidden = true; p.btn.setAttribute('aria-expanded', 'false'); p.r.classList.remove('is-open');
    if (devolverFoco) p.btn.focus();
  }
  function cerrarTodos(excepto) {
    document.querySelectorAll('[data-vn-cb].is-open').forEach(function (r) { if (r !== excepto) cerrar(parts(r), false); });
  }
  function elegir(p, o) {
    if (!o || o.classList.contains('vn-cb__opt--off') && false) return;
    var val = o.getAttribute('data-value');
    cerrar(p, true);
    if (p.sel.value === val) return;
    aplicar(p, val);
    vigilarFoco(p.btn);
  }
  function aplicar(p, val) {
    var found = false;
    Array.prototype.forEach.call(p.sel.options, function (op) { if (op.value === val) { found = true; } });
    if (!found) return false;
    p.sel.value = val;
    p.r.querySelectorAll('[data-vn-cb-val],[data-vn-cb-sel]').forEach(function (s) { s.textContent = val; });
    opts(p).forEach(function (x) { x.setAttribute('aria-selected', x.getAttribute('data-value') === val ? 'true' : 'false'); });
    p.sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  /* Dawn vuelve a pintar el selector tras el cambio: devolver el foco al botón nuevo (accesibilidad con teclado) */
  function vigilarFoco(orig) {
    var id = orig.id, t0 = Date.now();
    (function tick() {
      var cur = document.getElementById(id);
      if (cur && cur !== orig) {
        var ae = document.activeElement;
        if (!ae || ae === document.body || !document.contains(ae) || (ae.tagName === 'SELECT' && ae.closest('[data-vn-cb]'))) cur.focus();
        if (Date.now() - t0 < 4000 && document.activeElement !== cur) return setTimeout(tick, 80);
        if (Date.now() - t0 < 1500) return setTimeout(tick, 80);
        return;
      }
      if (Date.now() - t0 < 6000) setTimeout(tick, 80);
    })();
  }
  function init(r) {
    if (r.dataset.vnCbReady) return; r.dataset.vnCbReady = '1';
    r.classList.add('vn-cb--js'); r.querySelector('.vn-cb').hidden = false;
    var lab = r.querySelector('.vn-cb__label'); if (lab) lab.removeAttribute('for');
  }
  function initAll() { document.querySelectorAll('[data-vn-cb]').forEach(init); }
  function preseleccion() {
    if (/[?&]variant=/.test(location.search)) return;
    document.querySelectorAll('[data-vn-cb]').forEach(function (r) {
      var def = r.getAttribute('data-vn-default'), p = parts(r);
      if (def && p.sel && p.sel.value !== def) aplicar(p, def);
    });
  }

  document.addEventListener('click', function (e) {
    var r = root(e.target);
    if (!r) { cerrarTodos(null); return; }
    var p = parts(r);
    if (e.target.closest('.vn-cb__label')) { p.btn.focus(); return; }
    if (e.target.closest('.vn-cb__btn')) { if (p.panel.hidden) abrir(p, lastPointer !== 'touch' || e.detail === 0); else cerrar(p, true); return; }
    var o = e.target.closest('.vn-cb__opt'); if (o) elegir(p, o);
  });
  document.addEventListener('mousedown', function (e) { if (e.target.closest && e.target.closest('.vn-cb__opt')) e.preventDefault(); });
  document.addEventListener('mousemove', function (e) {
    var o = e.target.closest && e.target.closest('.vn-cb__opt'); if (o && !o.classList.contains('is-active')) setActive(parts(root(o)), o, false);
  });
  document.addEventListener('input', function (e) { if (e.target.classList && e.target.classList.contains('vn-cb__input')) filtrar(parts(root(e.target))); });
  /* el buscador no debe disparar el cambio de variante de Dawn */
  document.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('vn-cb__input')) e.stopPropagation(); }, true);
  document.addEventListener('keydown', function (e) {
    var t = e.target, r = root(t); if (!r) return;
    var p = parts(r);
    if (t === p.btn) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) !== -1 && p.panel.hidden) { e.preventDefault(); abrir(p, true); }
      else if (e.key === 'Escape' && !p.panel.hidden) { e.preventDefault(); cerrar(p, true); }
      return;
    }
    if (t !== p.input && t !== p.list) return;
    var v = visible(p), a = active(p), i = v.indexOf(a);
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); setActive(p, v[Math.min(v.length - 1, i + 1)] || v[0]); break;
      case 'ArrowUp': e.preventDefault(); setActive(p, v[Math.max(0, i - 1)] || v[0]); break;
      case 'PageDown': e.preventDefault(); setActive(p, v[Math.min(v.length - 1, i + 6)]); break;
      case 'PageUp': e.preventDefault(); setActive(p, v[Math.max(0, i - 6)]); break;
      case 'Home': if (t === p.list) { e.preventDefault(); setActive(p, v[0]); } break;
      case 'End': if (t === p.list) { e.preventDefault(); setActive(p, v[v.length - 1]); } break;
      case 'Enter': e.preventDefault(); if (a && !a.hidden) elegir(p, a); break;
      case ' ': if (t === p.list) { e.preventDefault(); if (a) elegir(p, a); } break;
      case 'Escape': e.preventDefault(); if (p.input.value && t === p.input) { p.input.value = ''; filtrar(p); } else cerrar(p, true); break;
      case 'Tab': cerrar(p, false); break;
      default:
        if (t === p.list && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) { p.input.focus(); }
    }
  });
  document.addEventListener('focusin', function (e) {
    document.querySelectorAll('[data-vn-cb].is-open').forEach(function (r) { if (!r.contains(e.target)) cerrar(parts(r), false); });
  });
  new MutationObserver(function () { initAll(); }).observe(document.documentElement, { childList: true, subtree: true });
  initAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); preseleccion(); });
  else { initAll(); setTimeout(preseleccion, 0); }
})();
